import { MuiTable } from "./MuiTable";
import { MuiButton } from "./MuiButton";
import { MuiTab } from "./MuiTab";
import { MuiTexField } from "./MuiTextField";
import { MuiListItem } from "./MuiListItem";
import { MuiCard } from "./MuiCard";
import { MuiDialog } from "./MuiDialog";
import { MuiDatePicker } from "./MuiCalendarPicker";

const overrides = {
  ...MuiTable,
  ...MuiButton,
  ...MuiTab,
  ...MuiTexField,
  ...MuiListItem,
  ...MuiCard,
  ...MuiDialog,
  ...MuiDatePicker,
};

export default overrides;
